import { render, staticRenderFns } from "./mastodon.connection.vue?vue&type=template&id=6389bb7e"
import script from "./mastodon.connection.vue?vue&type=script&lang=js"
export * from "./mastodon.connection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports